import { Injectable } from '@angular/core';

import { Selector, StateContext, Action, State } from '@ngxs/store';
import { Vehicle } from 'rest-client';

import { VehicleData } from '@app/modules/shared/models';

import { RemoveVehicleAction, SetVehicleAction } from './vehicle.actions';
import { VehicleStateModel } from './vehicle.model';

const INITIAL_STATE: VehicleStateModel = {
  vehicle: null,
  vehicleData: {
    id: null,
    umc: null,
    umcData: null,
    motorCode: null,
    motorDesc: null,
    bodyCode: null,
    bodyDesc: null,
    km: null,
    kmTimestamp: null,
    workshopType: null,
  },
};

@State<VehicleStateModel>({
  name: 'vehicle',
  defaults: INITIAL_STATE,
})
@Injectable()
export class VehicleState {
  @Selector()
  static vehicleData(state: VehicleStateModel): VehicleData {
    const { vehicleData } = state;
    return vehicleData;
  }

  @Selector()
  static vehicle(state: VehicleStateModel): Vehicle {
    const { vehicle } = state;
    return vehicle;
  }

  @Action(SetVehicleAction)
  setVehicleAction(
    ctx: StateContext<VehicleStateModel>,
    action: SetVehicleAction
  ): void {
    ctx.patchState({
      vehicle: action.vehicle,
      vehicleData: action.vehicleData,
    });
  }

  @Action(RemoveVehicleAction)
  removeVehicleAction(ctx: StateContext<VehicleStateModel>): void {
    ctx.setState(INITIAL_STATE);
  }
}
